@if (showOriginDestinationForm) {
  <div>
    <form id="hhgShipmentOriginDestinationForm" role="form"
      [formGroup]="hhgRateGlobalUpdateFormFilterGroup">
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="address_line1">{{addressLine1}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="address_line1" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
        <div class="form-group col-md-4">
          <label for="address_line2">{{addressLine2}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="address_line2" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="city_state_zip">{{cityStateZip}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="city_state_zip" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="country">{{country}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="country" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
        <div class="form-group col-md-4">
          <label for="alternative_phone">{{alternativePhone}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="alternative_phone" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="primary_phone">{{primaryPhone}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="primary_phone" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
        <div class="form-group col-md-4">
          <label for="ext">{{ext}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="ext" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="email">{{email}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="email" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
        <div class="form-group col-md-4">
          <label for="otherContactInformation">{{otherContactInformation}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="otherContactInformation" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
      </div>
    </form>
  </div>
}

@if (showAddreseeForm) {
  <div>
    <form id="hhgShipmentOriginDestinationAddresseeForm" role="form"
      [formGroup]="hhgRateGlobalUpdateFormFilterGroup">
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="addresee_address_line_1">{{addreseeAddressLine1}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="addresee_address_line_1" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
        <div class="form-group col-md-4">
          <label for="addresee_address_line_2">{{addreseeAddressLine2}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="addresee_address_line_2" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="addresee_city">{{addreseeCity}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="addresee_city" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
        <div class="form-group col-md-4">
          <label for="addresee_state">{{addreseeState}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="addresee_state" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
        <div class="form-group col-md-4">
          <label for="addresee_zip">{{addreseeZip}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="addresee_zip" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="addresee_country">{{addreseeCountry}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="addresee_country" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
        <div class="form-group col-md-4">
          <label for="addresee_email">{{addreseeEmail}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="addresee_email" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="addresee_phone">{{addreseePhone}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="addresee_phone" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
        <div class="form-group col-md-4">
          <label for="addresee_ext">{{addreseeExt}}</label>
          <input type="text" [attr.disabled]="disableTenderId?'':null"
            placeholder="Enter Your Tender ID" id="addresee_ext" class="w-100"
            formControlName="tenderId" [maxlength]="4">
        </div>
      </div>
    </form>
  </div>
}
